import { Reveal } from "./Reveal";
import { ValueStack } from "./ValueStack";
import { OfferCard } from "./OfferCard";
import { NatureBackdrop } from "./NatureBackdrop";

export const Plans = () => (
  <section data-testid="plans-section" className="relative overflow-clip bg-[var(--mist)] py-24 md:py-32">
    <img src="/assets/frame_5.webp" alt="" className="absolute inset-x-0 top-0 h-[1100px] w-full object-cover opacity-70" />
    <div className="absolute inset-x-0 top-0 h-[1100px] bg-gradient-to-b from-[#eef0ea]/40 via-[#eef0ea]/70 to-[var(--mist)]" />
    <NatureBackdrop />
    <div className="relative px-5">
      <Reveal className="text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.42em] text-[var(--moss-dark)]">Veja nosso plano</p>
        <h2 data-testid="plans-title" className="font-display mx-auto mt-5 max-w-3xl text-4xl leading-tight text-[var(--forest)] sm:text-5xl lg:text-6xl">
          Mergulhe em autoconhecimento <em>a partir de hoje!</em>
        </h2>
      </Reveal>
      <div className="mt-14">
        <ValueStack />
      </div>
      <div className="mt-20">
        <OfferCard />
      </div>
    </div>
  </section>
);
